import { auth } from '../sp-firebase/firebase';

const API_BASE_URL = (import.meta as any).env?.VITE_API_URL || 'http://localhost:8080';

async function getAuthHeaders(): Promise<Record<string, string>> {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('Not authenticated');
  }

  const token = await user.getIdToken();
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
}

export interface VMStatus {
  name: string;
  status: 'RUNNING' | 'TERMINATED' | 'STOPPING' | 'PROVISIONING' | 'STAGING';
  zone: string;
  machineType?: string;
  creationTimestamp?: string;
  lastStartTimestamp?: string;
  lastStopTimestamp?: string;
  networkInterfaces?: Array<{
    network?: string;
    internalIP?: string;
    externalIP?: string;
  }>;
}

export interface VMOperationResponse {
  message: string;
  status: string;
  operation?: string;
}

export const vmService = {
  /**
   * Get the current status of the Refinitiv fetcher VM
   */
  async getStatus(): Promise<VMStatus> {
    const headers = await getAuthHeaders();
    const response = await fetch(`${API_BASE_URL}/api/v2/vm/status`, { headers });
    if (!response.ok) {
      throw new Error(`Failed to get VM status: ${response.statusText}`);
    }
    return response.json();
  },

  /**
   * Start (resume) the Refinitiv fetcher VM
   */
  async start(): Promise<VMOperationResponse> {
    const headers = await getAuthHeaders();
    const response = await fetch(`${API_BASE_URL}/api/v2/vm/start`, {
      method: 'POST',
      headers,
    });
    if (!response.ok) {
      throw new Error(`Failed to start VM: ${response.statusText}`);
    }
    return response.json();
  },

  /**
   * Stop (suspend) the Refinitiv fetcher VM
   */
  async stop(): Promise<VMOperationResponse> {
    const headers = await getAuthHeaders();
    const response = await fetch(`${API_BASE_URL}/api/v2/vm/stop`, {
      method: 'POST',
      headers,
    });
    if (!response.ok) {
      throw new Error(`Failed to stop VM: ${response.statusText}`);
    }
    return response.json();
  },
};
